import styled from "styled-components";

const NothingIcon = styled.span`
  width: ${(p) => p.fontSize};
  height: ${(p) => p.fontSize};
  background-color: transparent;
`;

export default NothingIcon;
